import { RichTreeView } from "@mui/x-tree-view/RichTreeView";

interface IProps {
    files: FileNodeViewModel[];
    setSelectedFileContent: (file: string | null) => void;
}

export default function Contents(props: IProps) {
    const { files, setSelectedFileContent } = props;

    const findItemById = (files: FileNodeViewModel[], id: string | null): void => {
        if (id == null) {
            setSelectedFileContent(null);
            return;
        }
        for (const node of files) {
            if (node.id === id) {
                if (node.fileContent !== null) {
                    setSelectedFileContent(node.fileContent); 
                }
                return;
            }
            if (node.children) {
                findItemById(node.children, id);
            }
        }
    };

    return (
        <>
            {files && (
                <RichTreeView
                    items={files}
                    onItemClick={(_, itemId) => findItemById(files, itemId)}
                />
            )}
        </>
    );
}
